import unescape from 'lodash/unescape';
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {DESTINATION_DATA} from 'destination/destination-prop-types';
import DestinationSchema from 'destination/DestinationSchema';

const AirportHero = ({destination, city, isMobile, isNewDesignEnabled}) => {
    const subtitle = !isMobile
        ? 'Make flying easy with the smarter way to park and travel.'
        : 'Save Money. Save Time. Easy Checkout.';
    const classes = classNames('AirportHero', {
        'AirportHero-shortened': isNewDesignEnabled,
    });

    return (
        <div className={classes}>
            <div className="AirportHero-content">
                <div
                    className="SearchAirport-container"
                    itemScope
                    itemType="http://schema.org/Place"
                >
                    <h1 className="AirportHero-title">
                        {unescape(destination.title)} Parking
                        <meta
                            itemProp="name"
                            content={unescape(destination.title)}
                        />
                    </h1>
                    <DestinationSchema destination={destination} city={city} />
                    <span className="AirportHero-subtitle">{subtitle}</span>
                </div>
                {!isMobile && !isNewDesignEnabled && (
                    <div className="AirportHero-value-props">
                        <div className="AirportHero-value-prop">
                            <span className="AirportHero-icon AirportHero-icon-pricing" />
                            <h3>
                                Compare Daily Pricing
                                <small>and get a great deal</small>
                            </h3>
                        </div>
                        <div className="AirportHero-value-prop">
                            <span className="AirportHero-icon AirportHero-icon-times" />
                            <h3>
                                Check Shuttle Times
                                <small>
                                    so you can get to the terminal on time
                                </small>
                            </h3>
                        </div>
                        <div className="AirportHero-value-prop">
                            <span className="AirportHero-icon AirportHero-icon-ratings" />
                            <h3>
                                See Ratings
                                <small>
                                    from other drivers and park confidently
                                </small>
                            </h3>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

AirportHero.propTypes = {
    destination: PropTypes.shape(DESTINATION_DATA).isRequired,
    city: PropTypes.object.isRequired,
    isMobile: PropTypes.bool,
    isNewDesignEnabled: PropTypes.bool,
};

export default AirportHero;
